import {
	logicalSettings
} from "./logicalSettings.js"

import {
	v1 as UUID
} from "uuid";
import store from '@/store/index'
let wjQuestionTypeArr = store.state.wjQuestionTypeArr // 计分题
import _this from '@/main.js'
let Paper = function() {
	this.title = `<p style="text-align: center;"><span style="font-size: 20px"><strong><span style="color: #10ab97;">${_this.$t('Paper.Title')}</span></strong></span></p>` // 项目名称（问卷）
	this.depict = '感谢您能抽出几分钟时间来参加本次答题，现在我们就马上开始吧！' // 项目描述
	this.pageCount = 0 // 页码类型总数
	this.quesCount = 0 // 试题类型总数
	this.quesAtive = '' // 当前选中项
	this.endPageType = 0 // 完成的状态 0 正常 1 提前
	this.endPageNormalMsg = `<p style="text-align: center;">${_this.$t('Paper.endPageNormalMsg')}</p>` // 正常完成 结束页提示语
	this.endPageAdvanceMsg = `<p style="text-align: center;">${_this.$t('Paper.endPageAdvanceMsg')}</p>` // 提前完成 结束页提示语
	this.questionsList = new Array()

	this.cancleEdit = function() {
		for (var i = 0; i < this.questionsList.length; i++) {
			if (this.questionsList[i].isedit == true) {
				this.quesAtive = this.questionsList[i].qid
			}
			this.questionsList[i].isedit = false;
		}
	}
	/**
	 * @description 创建试题
	 * @param {*} qType 试题类型
	 * @param {*} optionNum 选项个数
	 * @param {*} rowsNum 矩阵行个数
	 * @param {*} columnsNum 矩阵列个数
	 */
	this.createQuestion = function(qType, optionNum, rowsNum, columnsNum) {
		console.log('qType, optionNum, rowsNum, columnsNum :>> ', qType, optionNum, rowsNum, columnsNum);
		var q = new Question()
		q.qid = UUID();
		q.questionsTypeId = qType
		q = logicalSettings(q)
		// 除段落描述、页码以外
		if (wjQuestionTypeArr.indexOf(qType) != -1) {
			q.quesCode = '' // 问题编码
			q.mustanswer = true; //是否必填
			let index = 0
			this.questionsList.forEach((item) => {
				if (wjQuestionTypeArr.indexOf(item.questionsTypeId) != -1) {
					index++
				}
			})
			q.quesIndex = index
			this.quesCount++
		}
		switch (qType) {
			case '2':
				q.format = 5 // 内容限制
				q.inputHeight = _this.$t('main.small') // 输入框高度
				q.maxNum = 0
				q.minNum = 0
				q.decimalPlaces = 0
				q.questionsName = _this.$t('main.cellPhoneNumber')
				break;
			case '3':
				q.format = 0 // 内容限制
				q.questionsName = _this.$t('main.SingleLineInputBox')
				q.maxNum = 0
				q.minNum = 0
				q.decimalPlaces = 0
				q.cutType = 1 // 单行输入框
				break;
			case '4':
				q.format = 0 // 内容限制
				// q.inputHeight = _this.$t('main.big') // 输入框高度
				q.questionsName = _this.$t('main.MultilineInputBox')
				q.maxNum = 0
				q.minNum = 0
				q.decimalPlaces = 0
				q.cutType = 2 // 多行输入框
				break;
			case '5':
				q.format = 0 // 内容限制
				q.inputHeight = _this.$t('main.small') // 输入框高度
				q.questionsName = _this.$t('main.PleaseFillOInThisItem')
				q.maxNum = 0
				q.minNum = 0
				q.decimalPlaces = 0
				break;
			case '6':
				q.optionList = []
				q.optionIfRandom = 0 // 选项随机排列
				q.ifFixedLastOption = 0 // 固定最后一个选项
				q.questionsName = _this.$t('main.PleaseSelectTheFollowingImage')
				q.cutType = 7 // 图片单选
				q.maxOptionsNum = 0 // 最多可选几项 0(不限)
				q.minOptionsNum = 0 // 最少可选几项 0(不限)
				break;
			case '8':
				q.createDefaultOption(optionNum)
				q.optionIfRandom = 0 // 选项随机排列
				q.ifFixedLastOption = 0 // 固定最后一个选项
				q.questionsName = _this.$t('main.PleaseSelectAnOption')
				q.cutType = 3 // 单选
				q.showcolnum = 1 // 选项布局
				q.relation = [{
					id: ''
				}] // 试题关联选项的试题id
				q.associated = [] // 被关联的试题id
				q.groupingOptionList = [] // 分组
				q.scoreOrNot = 0 // 是否开启分值设置
				q.isClosedLoop = 0 // 是否闭环
				break;
			case '9':
				q.createDefaultOption(optionNum)
				q.optionIfRandom = 0 // 选项随机排列
				q.ifFixedLastOption = 0 // 固定最后一个选项
				q.relation = [{
					id: ''
				}] // 试题关联选项的试题id
				q.associated = [] // 被关联的试题id
				q.questionsName = _this.$t('main.PleaseSelectAnOption')
				break;
			case '10':
				q.createDefaultOption(optionNum)
				q.optionIfRandom = 0 // 选项随机排列
				q.ifFixedLastOption = 0 // 固定最后一个选项
				q.questionsName = _this.$t('main.SelectMultipleOptions')
				q.cutType = 4 // 多选
				q.showcolnum = 1 // 选项布局
				q.relation = [{
					id: ''
				}] // 试题关联选项的试题id
				q.associated = [] // 被关联的试题id
				q.maxOptionsNum = 0 // 最多可选几项 0(不限)
				q.minOptionsNum = 0 // 最多可选几项 0(不限)
				q.groupingOptionList = [] // 分组
				break;
			case '11':
				q.scoreImg = 'star' // 样式显示
				q.questionsName = _this.$t('main.StarRating')
				q.lowestScore = 1 // 最低分
				q.highestScore = 5 // 最高分
				q.score = 0 // 得分
				q.leftPromptText = ''
				q.centerPromptText = ''
				q.rightPromptText = ''
				q.scoreOrNot = 0 // 是否开启分值设置
				q.percentageNum = 1 // 分值百分比
				break;
			case '12':
				q.createDefaultOption(optionNum)
				q.questionsName = _this.$t('main.PleaseSelectAnOption')
				q.scoreOrNot = 0 // 是否开启分值设置
				q.isClosedLoop = 0 // 是否闭环
				break;
			case '13':
				q.questionsName = _this.$t('main.DateSelection')
				q.startDateType = 0 //起始日期 0为不限制,1填写当日,2指定日期
				q.deadlineType = 0 //截止日期 0为不限制,1起始日期后,2指定日期
				q.startDate = '' //起始日期 空为不限制
				q.deadline = '' //截止日期 空为不限制
				break;
			case '14':
				q.createDefaultOption(optionNum)
				q.questionsName = _this.$t('main.SortTheFollowingOptions')
				q.optionIfRandom = 0 // 选项随机排列
				q.ifFixedLastOption = 0 // 固定最后一个选项
				q.sortsnums = 0 // 仅选出几位
				break;
			case '15':
				q.manualCorrectionPosition = false // 不允许手动修正位置
				q.questionsName = _this.$t('main.addressLocation')
				break;
			case '16':
				q.choiceRange = 4 // 详细程度
				q.questionsName = _this.$t('main.CitySelection')
				break;
			case '17':
				q.questionsName = _this.$t('main.time')
				break;
			case '19':
				q.createDefaultOption(optionNum, rowsNum, columnsNum)
				q.cutType = 5 // 矩阵单选
				q.questionsName = _this.$t('main.SelectTheFollowingOptions')
				q.matrixLineRandom = false //「列」随机排列
				q.matrixRankRandom = false //「行」随机排列
				q.lineRankExchange = false // 矩阵行列交换
				q.fillBoxSlide = false // 手机端填写框可滑动出现
				break;
			case '20':
				q.createDefaultOption(optionNum, rowsNum, columnsNum)
				q.cutType = 6 // 矩阵多选
				q.questionsName = _this.$t('main.SelectTheFollowingOptions')
				q.matrixLineRandom = false //「列」随机排列
				q.matrixRankRandom = false //「行」随机排列
				q.lineRankExchange = false // 矩阵行列交换
				q.maxOptionsNum = 0 // 最多可选几项 0(不限)
				q.minOptionsNum = 0 // 最多可选几项 0(不限)
				q.fillBoxSlide = false // 手机端填写框可滑动出现
				break;
			case '21':
				q.createDefaultOption(optionNum, rowsNum, columnsNum)
				q.questionsName = _this.$t('main.RateTheFollowingItems')
				q.highestScore = 5 // 最高分
				q.matrixLineRandom = false //「列」随机排列
				q.matrixRankRandom = false //「行」随机排列
				q.lineRankExchange = false // 矩阵行列交换
				q.fillBoxSlide = false // 手机端填写框可滑动出现
				break;
			case '22':
				q.createDefaultOption(optionNum, rowsNum, columnsNum)
				q.questionsName = _this.$t('main.FillInTheFollowingInformation')
				q.matrixLineRandom = false //「列」随机排列
				q.matrixRankRandom = false //「行」随机排列
				q.lineRankExchange = false // 矩阵行列交换
				q.fillBoxSlide = false // 手机端填写框可滑动出现
				break;
			case '25':
				q.questionsName = _this.$t('main.Headings')
				q.mustanswer = false
				q.quesCode = '' // 问题编码
				break;
			case '26':
				if (this.questionsList.length > 0 && this.questionsList[0].questionsTypeId != '26') {
					var pageQ = new Question()
					pageQ.qid = UUID();
					pageQ.questionsTypeId = qType
					pageQ.pageNumber = 1
					pageQ.minTimeSwitch = false
					pageQ.minTime = 0 // 最短时间
					pageQ.maxTimeSwitch = false
					pageQ.maxTime = 0 // 最长时间
					pageQ.nextBtnText = _this.$t('main.NextPage')
					pageQ.isedit = false
					pageQ.isShow = true
					pageQ.bindIsShow = true

					this.questionsList.unshift(pageQ)
					this.pageCount++
				}
				let index = 0
				this.questionsList.forEach((item) => {
					if (item.questionsTypeId == '26') {
						index++
					}
				})
				q.pageNumber = index + 1
				q.minTimeSwitch = false
				q.minTime = 0
				q.maxTimeSwitch = false
				q.maxTime = 0
				q.nextBtnText = _this.$t('main.NextPage')
				q.lastBtnText = _this.$t('main.LastPage')
				q.lastBtnShow = true // 显示上一页按钮
				this.pageCount++
				break;
			case '33':
				q.maxFilesNum = 1 // 最大上传文件数量
				q.questionsName = _this.$t('main.UploadFiles')
				break;
			case '34':
				q.questionsName = _this.$t('main.FillInTheFollowingInformation')
				q.quesOptionTitle = `${_this.$t('main.FullName')}________${_this.$t('main.Age')}____${_this.$t('main.Year')} ${_this.$t('main.ContactInformation')}___________` // 用于存储横向填空的填空部分
				let arr = q.quesOptionTitle.match(/_[_]+_/g)
				q.optionList = []
				if (arr.length > 0) {
					arr.forEach((info, index) => {
						let obj = {
							oid: UUID(),
							length: info.length,
							labelName: index + 1,
							optionScore: 0,
							format: 0, // 输入框格式
							mustanswer: true,
							minNum: 0,
							maxNum: 0,
							decimalPlaces: 0
						}
						q.optionList.push(obj)
					})
				}
				break;
			case '35':
				q.createDefaultOption(optionNum)
				q.optionIfRandom = 0 // 选项随机排列
				q.ifFixedLastOption = 0 // 固定最后一个选项
				q.questionsName = _this.$t('main.FillInTheFollowingInformation')
				break;
			case '36':
				// type 判断是 选择 还是输入框 1选择 2输入
				q.questionsName = _this.$t('main.CascadeQuestions')
				q.optionPlaceholder1 = _this.$t('main.PleaseSelect')
				q.optionPlaceholder2 =  _this.$t('main.PleaseSelect')
				q.optionPlaceholder3 =  _this.$t('main.PleaseSelect')
				q.optionPlaceholder4 =  _this.$t('main.PleaseSelect')
				q.optionValue = [] //结果存放
				q.optionList = [{
					id: UUID(),
					value: `${_this.$t('main.option')}1`,
					label: `${_this.$t('main.option')}1`,
					type: 1,
					children: [{
						id: UUID(),
						value: `${_this.$t('main.option')}1-1`,
						label: `${_this.$t('main.option')}1-1`,
						type: 1,
					}]
				}]
				break;
			case '37':
				q.createDefaultOption(optionNum)
				q.optionIfRandom = 0 // 选项随机排列
				q.ifFixedLastOption = 0 // 固定最后一个选项
				q.isLimitSum = true // 限制总和
				q.sum = 100 // 总和
				q.isLimitNum = true // 限制比重最大最小值
				q.minNum = 0 // 最小值
				q.maxNum = 100 // 最大值
				q.decimalPlaces = 0
				q.questionsName = _this.$t('main.PercentageOfEachItem')
				break;
			case '38':
				q.extremumTag = 1 // 极值标签 默认1 满意度
				q.questionsName = _this.$t('main.EvaluateThisProject')
				q.orderSetting = 5 // 量级设置
				q.startNum = 1 // 起始数值
				q.leftText = _this.$t('main.VeryDissatisfied')
				q.rightText = _this.$t('main.VerySatisfied')
				q.displayStyle = 0 // 显示样式 默认1 数字
				q.scoreOrNot = 0 // 是否开启分值设置
				q.percentageNum = 1 // 分值百分比
				break;
			case '39':
				q.createDefaultOption(optionNum)
				q.questionsName = _this.$t('main.FillInMemberInformation')
				q.matrixLineRandom = false //「行」随机排列
				q.matrixRankRandom = false //「列」随机排列
				q.lineRankExchange = false // 矩阵行列交换
				q.fillBoxSlide = false // 手机端填写框可滑动出现
				break;
		}
		if (this.questionsList.length > 0) {
			let result = false
			this.questionsList.forEach((info, index) => {
				if (this.quesAtive && info.qid == this.quesAtive) {
					result = true
					this.questionsList.splice(index + 1, 0, q)
				}
			})
			if (result == false) {
				this.questionsList.push(q)
			}
		} else {
			this.questionsList.push(q)
		}
	}
	// 删除一个问题
	this.delQuestion = function(qid) {
		for (var i = 0; i < this.questionsList.length; i++) {
			if (qid == this.questionsList[i].qid) {
				this.questionsList.splice(i, 1)
				break;
			}
		}
	}
	// 复制问题
	this.copyQuestion = function(ques, index) {
		let question = JSON.parse(JSON.stringify(ques))
		question.qid = UUID()
		question.bqid = ''
		question.isedit = true
		question = logicalSettings(question)
		this.questionsList.splice(index + 1, 0, question);

	}
	// 初始化逻辑
	this.initlogicalSettings = function(ques) {
		ques = logicalSettings(ques)
	}
}


// 问题类
let Question = function() {
	this.qid = 0; // 试题id
	this.isedit = true // 新添加的问题设置为编辑状态
	this.questionsTypeId = ""; // 试题类型
	this.questionsName = ""; // 试题名称
	this.isShow = true
	this.bindIsShow = true
	this.optionList = new Array();
	this.questionsSonList = new Array();
	/**
	 * 
	 * @param {*} optionNum 选项个数
	 * @param {*} rowsNum 矩阵行个数
	 * @param {*} columnsNum 矩阵列个数
	 */
	this.createDefaultOption = function(optionNum = 2, rowsNum = 2, columnsNum = 2) {
		switch (this.questionsTypeId) {
			case '35':
				for (var i = 0; i < optionNum; i++) {
					let option = new Option()
					option.oid = UUID()
					option.labelName = _this.$t('main.fillInTheBlanks') + (i + 1)
					option.notAnswer = false // 可不填
					option.format = 0
					option.minNum = 0 // 最多填写
					option.maxNum = 0 // 最少填写
					option.decimalPlaces = 0
					option.userAnswer = '' // 默认文本
					option.inputHeight = '小'
					option.isDefault = true // 默认添加的选项
					this.optionList.push(option)
				}
				break
			case '37':
				for (var i = 0; i < optionNum; i++) {
					let option = new Option()
					option.oid = UUID()
					option.labelName = _this.$t('main.Proportion') + (i + 1)
					option.userAnswer = 0
					option.isDefault = true // 默认添加的选项
					this.optionList.push(option)
				}
				break
			case '8':
			case '10':
				for (var i = 0; i < optionNum; i++) {
					let option = new Option()
					option.oid = UUID()
					option.labelName = _this.$t('main.option') + (i + 1)
					option.haveInput = false
					option.inputValue = ''
					option.minNum = 0
					option.maxNum = 0
					option.decimalPlaces = 0
					option.isDefault = true // 默认添加的选项
					this.optionList.push(option)
				}
				break
			case '9':
			case '14':
				for (var i = 0; i < optionNum; i++) {
					let option = new Option()
					option.oid = UUID()
					option.labelName = _this.$t('main.option') + (i + 1)
					option.haveInput = false
					option.inputValue = ''
					option.isDefault = true // 默认添加的选项
					this.optionList.push(option)
				}
				break
			case '12':
				let arr = [{
						oid: UUID(),
						labelName: _this.$t('main.Correct')
					},
					{
						oid: UUID(),
						labelName: _this.$t('main.Error')
					}
				]
				this.optionList = arr
				break
			case '19':
				for (var i = 0; i < rowsNum; i++) {
					let questionsSonList = new QuestionsSonList(this.questionsTypeId, columnsNum)
					questionsSonList.SonId = UUID()
					questionsSonList.questionsName = _this.$t('main.MatrixRow') + (i + 1)
					questionsSonList.isSelected = ''
					questionsSonList.isDefault = true // 默认添加的选项
					if (i == 1) {
						questionsSonList.optionList = this.questionsSonList[0].optionList.map(info => {
							return info
						})
					}
					this.questionsSonList.push(questionsSonList)
				}
				break
			case '20':
				for (var i = 0; i < rowsNum; i++) {
					let questionsSonList = new QuestionsSonList(this.questionsTypeId, columnsNum)
					questionsSonList.SonId = UUID()
					questionsSonList.questionsName = _this.$t('main.MatrixRow') + (i + 1)
					questionsSonList.isSelected = []
					questionsSonList.isDefault = true // 默认添加的选项
					if (i == 1) {
						questionsSonList.optionList = this.questionsSonList[0].optionList.map(info => {
							return info
						})
					}
					this.questionsSonList.push(questionsSonList)
				}
				break
			case '21':
			case '22':
				for (var i = 0; i < rowsNum; i++) {
					let questionsSonList = new QuestionsSonList(this.questionsTypeId, columnsNum)
					questionsSonList.SonId = UUID()
					questionsSonList.questionsName = _this.$t('main.MatrixRow') + (i + 1)
					questionsSonList.isDefault = true // 默认添加的选项
					if (i == 1) {
						questionsSonList.optionList = this.questionsSonList[0].optionList.map(info => {
							return info
						})
					}
					this.questionsSonList.push(questionsSonList)
				}
				break
			case '39':
				for (var i = 0; i < optionNum; i++) {
					let questionsSonList = new QuestionsSonList(this.questionsTypeId)
					questionsSonList.SonId = UUID()
					questionsSonList.questionsName = _this.$t('main.member') + (i + 1)
					questionsSonList.isDefault = false // 默认添加的选项
					questionsSonList.type = '2' 
					questionsSonList.format = '' //验证
					questionsSonList.options = '' //下拉
					questionsSonList.optionName = `${_this.$t('main.option')}1;${_this.$t('main.option')}2` //下拉
					questionsSonList.fileList= ''//上传文件
					questionsSonList.value= ''//值
					questionsSonList.minNum = 0 // 最少填写
					questionsSonList.maxNum = 0 // 最多填写
					questionsSonList.decimalPlaces = 0
					if (i == 1) {
						questionsSonList.optionList = this.questionsSonList[0].optionList.map(info => {
							return info
						})
					}
					this.questionsSonList.push(questionsSonList)
				}
				break
		}
	}
}

let Option = function() {
	this.oid = 0;
	this.labelName = "";
}

/**
 * 生成矩阵列
 * @param {*} questionsTypeId 试题类型
 * @param {*} columnsNum 矩阵列个数
 */
let QuestionsSonList = function(questionsTypeId, columnsNum) { // 行
	this.SonId = 0
	this.optionList = new Array();
	switch (questionsTypeId) {
		case '19':
			for (var i = 0; i < columnsNum; i++) {
				let option = new Option()
				option.oid = UUID()
				option.labelName = _this.$t('main.option') + (i + 1)
				option.haveInput = false
				option.inputValue = ''
				option.format = 0 // 内容限制
				option.isMaxNum = false // 字数限制开关
				option.minNum = 0 // 字数限制
				option.maxNum = 0 // 字数限制
				option.decimalPlaces = 0
				option.notAnswer = true // 该空可不填
				option.isDefault = true // 默认添加的选项
				this.optionList.push(option)
			}
			break
		case '20':
			for (var i = 0; i < columnsNum; i++) {
				let option = new Option()
				option.oid = UUID()
				option.labelName = _this.$t('main.option') + (i + 1)
				option.haveInput = false
				option.inputValue = ''
				option.format = 0 // 内容限制
				option.isMaxNum = false // 字数限制开关
				option.minNum = 0 // 字数限制
				option.maxNum = 0 // 字数限制
				option.decimalPlaces = 0
				option.notAnswer = true // 该空可不填
				option.isDefault = true // 默认添加的选项
				this.optionList.push(option)
			}
			break
		case '21':
			for (var i = 0; i < columnsNum; i++) {
				let option = new Option()
				option.oid = UUID()
				option.labelName = _this.$t('main.Scoring') + (i + 1)
				option.ratingScore = 0
				option.isDefault = true // 默认添加的选项
				this.optionList.push(option)
			}
			break
		case '22':
			for (var i = 0; i < columnsNum; i++) {
				let option = new Option()
				option.oid = UUID()
				option.labelName = _this.$t('main.fillInTheBlanks') + (i + 1)
				option.minNum = 0 // 字数限制
				option.maxNum = 0 // 字数限制
				option.decimalPlaces = 0
				option.userAnswer = '' // 默认文本
				option.notAnswer = false // 该空可不填
				option.isDefault = true // 默认添加的选项
				this.optionList.push(option)
			}
			break
		case '39':
			for (var i = 0; i < 2; i++) {
				let option = new Option()
				option.oid = UUID()
				option.labelName = _this.$t('main.fillInTheBlanks') + (i + 1)
				option.type = '2' // 1填空 2下拉 3上传
				option.format = '' //验证
				option.options = [] //下拉
				option.optionName = `${_this.$t('main.option')}1;${_this.$t('main.option')}2` //下拉
				option.fileList= ''//上传文件
				option.value= ''//值
				option.minNum = 0 // 字数限制
				option.maxNum = 0 // 字数限制
				option.decimalPlaces = 0
				option.userAnswer = '' // 默认文本
				option.notAnswer = false // 该空可不填
				option.isDefault = true // 默认添加的选项
				option.fileList=[]
				this.optionList.push(option)
			}
			break
	}

}
export default Paper;
